import * as React from 'react';

import {Button} from 'shells/button/button';
import {StackLegacy} from 'shells/layout/stack/stack-legacy';
import {Body} from 'shells/typography/body';
import {MarketingHeader} from 'shells/typography/marketing-header';

import {Embedded} from '../../core/embedded';

import {CalendarConnectButtons} from './calendar-connect-buttons';
import {ConflictCalendarWidget} from './conflict-calendar-widget';
import {
    useRemoveConflictCalendar,
    useSelectConflictCalendar,
    useGetCalendars,
} from './graphql/hooks';
import {SelectCalendarModalWrapper} from './select-calendar-modal/select-calendar-modal-wrapper';

type ConflictCalendarsProps = {
    errorMessages: string[];
    setErrorMessages: (errorMessages: string[]) => void;
};

export function ConflictCalendars(props: ConflictCalendarsProps) {
    const [wasAuthSuccessful, setWasAuthSuccessful] = React.useState(false);
    const [isSelectCalendarModalOpen, setIsSelectCalendarModalOpen] = React.useState(false);
    const [isAddingCalendar, setIsAddingCalendar] = React.useState(false);
    const [username, setUsername] = React.useState<string | null | undefined>(null);

    const {calendars} = useGetCalendars();
    const {removeConflictCalendar} = useRemoveConflictCalendar();
    const {selectConflictCalendar} = useSelectConflictCalendar();

    const hasConflictCalendars = calendars && calendars.length > 0;

    return (
        <div>
            <MarketingHeader>
                We’ll use these calendars to prevent conflicts in {/* @ts-expect-error */}
                <Embedded default='Scheduler' embedded='SchedulerFX' />
            </MarketingHeader>
            <div className='flex flex-dir-col gap-12'>
                <Body>Add more calendars to prevent scheduling conflicts.</Body>
                {hasConflictCalendars && (
                    <StackLegacy spacing={8}>
                        {calendars.map((calendar) => {
                            return (
                                <div key={calendar.name}>
                                    <ConflictCalendarWidget
                                        calendar={calendar}
                                        onConfirmDisconnect={removeConflictCalendar}
                                    />
                                </div>
                            );
                        })}
                        {!isAddingCalendar && (
                            <Button
                                variant='text-primary'
                                onClick={() => {
                                    setIsAddingCalendar(true);
                                }}
                                size='xlarge'
                                noPadding={true}
                            >
                                Add another calendar
                            </Button>
                        )}
                    </StackLegacy>
                )}
                {(isAddingCalendar || !hasConflictCalendars) && (
                    <div className='flex gap-8'>
                        <CalendarConnectButtons
                            isForConflictCalendar={true}
                            calendarSync={null}
                            errorMessages={props.errorMessages}
                            setErrorMessages={props.setErrorMessages}
                            onAuthSuccess={(result) => {
                                setWasAuthSuccessful(true);
                                setIsSelectCalendarModalOpen(true);
                                setIsAddingCalendar(false);
                                setUsername(result && result.username);
                            }}
                            onAuthStart={() => {
                                setWasAuthSuccessful(false);
                            }}
                            isFullWidth={true}
                        />
                    </div>
                )}
                {username && wasAuthSuccessful && isSelectCalendarModalOpen && (
                    <SelectCalendarModalWrapper
                        username={username}
                        isOpen={isSelectCalendarModalOpen}
                        onClose={() => setIsSelectCalendarModalOpen(false)}
                        modalType='conflict'
                        onSave={(calendarId) => {
                            return selectConflictCalendar(calendarId);
                        }}
                    />
                )}
            </div>
        </div>
    );
}
